module.exports = __webpack_public_path__ + "img/logo-mobile.a72dc5c2.svg";